import styled from 'styled-components';
import { CardProps } from '.';
import Lupa from  '../../../../../public/lupa.svg'
import LupaGray from  '../../../../../public/lupaGray.svg'
import LupaBlack from  '../../../../../public/lupaBlack.svg'
interface ContainerProps {
  background?: string;
}
export const Container = styled.div<ContainerProps>`
  margin: 2rem 0 0 0;
  background:  ${props => props.background ? props.background: 'white' }4d;
  grid-area: indicator_synthesis;
  min-height: 370px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 3px;

  .icon{
    margin-bottom: 13px;
  }
  h3{
    color: #161615;
    font-size: 24px;
  }
  .subtitle{
    font: Poppins;
    font-size: 14px;
    letter-spacing: 1.4px;
    color: #161615;
    font-weight: 500;
    margin-bottom: 21px;
  }

  @media (max-width: 820px) {
    height: auto;
    padding: 30px 0;
  }
`;


export const ContainerCard = styled.div<CardProps>`
  width: 180px;
  height: 170px;
  background: ${props => props.background ? props.background: 'white' } 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  margin-left: 12px;
 padding: 12px;
  p{
    text-align: center;
    font: normal normal 600 15px/19px Poppins;
    letter-spacing: 0.3px;
    color: #FFFFFF;
    opacity: 1;
    margin: 0.5rem 0;
  }
  @media (max-width: 820px) {
    margin-bottom: 12px;
    margin-left: 0;
  }
  &:hover{
    background: ${props => props.background ? props.background: 'white' }80 0% 0% no-repeat padding-box;
    cursor: pointer;
  }
`

export const LayerDiv = styled.div`
  display: flex;
  @media (max-width: 820px) {
    flex-direction: column;
  }

`


export const LupaSearch = styled(Lupa)`
`
export const LupaSearchGray = styled(LupaGray)`

`
export const LupaSearchBlack = styled(LupaBlack)`
`